export default function PHP_headers_sent() {
  return (
    <div>
      <h1>PHP_headers_sent</h1>
    </div>
  );
}
